export const isMobileActive = () => {
    return localStorage.getItem('isMobileActived');
};
